"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElapsedTime = exports.getUpdateDeltaScaled = exports.getUpdateDelta = exports.setUpdateDeltaScaled = exports.setUpdateDelta = exports.getGameSize = exports.setPhaserScene = exports.getPhaserScene = exports.hasScene = exports.createId = void 0;
var game_1 = require("./game");
var id = 100;
function createId() {
    id++;
    return id;
}
exports.createId = createId;
var _scene = null;
function hasScene() {
    return _scene != null;
}
exports.hasScene = hasScene;
function getPhaserScene() {
    if (!_scene) {
        throw new Error('no scene');
    }
    return _scene;
}
exports.getPhaserScene = getPhaserScene;
function setPhaserScene(scene) {
    _scene = scene;
}
exports.setPhaserScene = setPhaserScene;
function getGameSize() {
    // let height = getPhaserScene().game.config.height as number
    // let width = getPhaserScene().game.config.width as number
    var w = window.innerWidth * (0, game_1.getDevicePixelRatio)();
    var h = window.innerHeight * (0, game_1.getDevicePixelRatio)();
    return { width: w, height: h };
}
exports.getGameSize = getGameSize;
var _updateDeltaTime = 0;
var _updateDeltaTimeScaled = 0;
var _elapsedTime = 0;
function setUpdateDelta(updateTime) {
    _updateDeltaTime = updateTime;
    _elapsedTime += updateTime;
}
exports.setUpdateDelta = setUpdateDelta;
function setUpdateDeltaScaled(updateTimeScaled) {
    _updateDeltaTimeScaled = updateTimeScaled;
}
exports.setUpdateDeltaScaled = setUpdateDeltaScaled;
function getUpdateDelta() {
    return _updateDeltaTime;
}
exports.getUpdateDelta = getUpdateDelta;
function getUpdateDeltaScaled() {
    return _updateDeltaTimeScaled;
}
exports.getUpdateDeltaScaled = getUpdateDeltaScaled;
function getElapsedTime() {
    return _elapsedTime;
}
exports.getElapsedTime = getElapsedTime;
